import React, { FC, PropsWithChildren } from 'react';

import { InformationCard } from 'app/components/information-card';

import { BaseInformationStep, BaseInformationStepProps } from './base-information-step';
import { StyledContentPlaceholder } from './product-information-step.styled';

export const ProductInformationStep: FC<PropsWithChildren<BaseInformationStepProps>> = (props) => {
    const { loading, children, ...rest } = props;

    return (
        <BaseInformationStep {...rest} loading={loading}>
            {loading ? (
                <InformationCard $showBordersForMobile={true}>
                    <StyledContentPlaceholder numberOfRows={2} hasTitle={true} />
                </InformationCard>
            ) : (
                children
            )}
        </BaseInformationStep>
    );
};
